import { type AuthState, useAuth } from '@/contexts/AuthContext';
import { useFocusEffect } from 'expo-router';
import { useCallback, useState } from 'react';

export function useAuthedApi<T>(
  callback: (token: string) => Promise<T>
):
  | { loading: true; data: null; authState: AuthState }
  | { loading: false; data: T; authState: AuthState } {
  const [data, setData] = useState<T | null>(null);
  const { authState } = useAuth();

  useFocusEffect(
    useCallback(() => {
      let isActive = true;

      async function fetchData() {
        if (!authState.loading && authState.token) {
          try {
            const result = await callback(authState.token);
            if (isActive) {
              setData(result);
            }
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        }
      }

      fetchData();

      return () => {
        isActive = false;
      };
    }, [authState.loading, authState.token, callback])
  );

  if (data) {
    return { loading: false, data, authState } as const;
  }

  return { loading: true, data: null, authState } as const;
}
